import React, { useState, useRef } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    praxis: '',
    email: '',
    phone: '',
    message: '',
    quickCheck: false
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const formRef = useRef();
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    // EmailJS-Anmeldedaten
    const serviceId = 'service_xhbu8ke';
    const templateId = 'template_vx45ler';
    const publicKey = 'f_fWfEX5x5ppA9sp3';
    // EmailJS initialisieren
    emailjs.init(publicKey);
    // Formular vorbereiten
    const templateParams = {
      from_name: formData.name,
      praxis: formData.praxis,
      reply_to: formData.email,
      phone: formData.phone,
      message: formData.message,
      quickCheck: formData.quickCheck ? 'Ja' : 'Nein'
    };
    // E-Mail senden
    emailjs.send(serviceId, templateId, templateParams).then(result => {
      console.log('Email sent successfully:', result.text);
      setFormSubmitted(true);
      setIsSubmitting(false);
    }).catch(error => {
      console.error('Failed to send email:', error);
      setError('Es gab ein Problem beim Versenden Ihrer Anfrage. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns direkt per Telefon.');
      setIsSubmitting(false);
    });
  };
  return <section id="kontakt" className="py-16 bg-gray-50" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center" data-id="element-177">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-178">
            Kontakt
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-179">
            Lassen Sie uns gemeinsam prüfen, wie sicher Ihre Praxis ist – bevor
            es die KBV tut.
          </p>
        </div>
        <div className="mt-12 lg:grid lg:grid-cols-2 lg:gap-8" data-id="element-180">
          <div data-id="element-181">
            {formSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-8 h-full flex flex-col justify-center" data-id="element-182">
                <div className="flex items-center justify-center h-12 w-12 rounded-full bg-green-100 text-green-600 mx-auto mb-4" data-id="element-183">
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-184">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-185" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-green-800 text-center mb-2" data-id="element-186">
                  Vielen Dank für Ihre Anfrage!
                </h3>
                <p className="text-green-700 text-center" data-id="element-187">
                  Wir werden uns innerhalb von 24 Stunden mit Ihnen in
                  Verbindung setzen, um einen Termin für Ihre kostenlose
                  Erstberatung zu vereinbaren.
                </p>
              </div> : <form ref={formRef} onSubmit={handleSubmit} className="bg-white rounded-lg p-8 shadow-sm h-full flex flex-col" data-id="element-188">
                {error && <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-id="element-189">
                    {error}
                  </div>}
                <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8 flex-grow" data-id="element-190">
                  <div data-id="element-191">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-192">
                      Name *
                    </label>
                    <div className="mt-1" data-id="element-193">
                      <input type="text" name="name" id="name" required value={formData.name} onChange={handleChange} className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 rounded-md" data-id="element-194" />
                    </div>
                  </div>
                  <div data-id="element-195">
                    <label htmlFor="praxis" className="block text-sm font-medium text-gray-700" data-id="element-196">
                      Praxis *
                    </label>
                    <div className="mt-1" data-id="element-197">
                      <input type="text" name="praxis" id="praxis" required value={formData.praxis} onChange={handleChange} className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 rounded-md" data-id="element-198" />
                    </div>
                  </div>
                  <div data-id="element-199">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-200">
                      E-Mail *
                    </label>
                    <div className="mt-1" data-id="element-201">
                      <input type="email" name="email" id="email" required value={formData.email} onChange={handleChange} className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 rounded-md" data-id="element-202" />
                    </div>
                  </div>
                  <div data-id="element-203">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-204">
                      Telefon
                    </label>
                    <div className="mt-1" data-id="element-205">
                      <input type="tel" name="phone" id="phone" value={formData.phone} onChange={handleChange} className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 rounded-md" data-id="element-206" />
                    </div>
                  </div>
                  <div className="sm:col-span-2" data-id="element-207">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-208">
                      Nachricht
                    </label>
                    <div className="mt-1" data-id="element-209">
                      <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 rounded-md" data-id="element-210"></textarea>
                    </div>
                  </div>
                  <div className="sm:col-span-2" data-id="element-211">
                    <div className="flex items-start" data-id="element-212">
                      <div className="flex-shrink-0" data-id="element-213">
                        <input id="quickCheck" name="quickCheck" type="checkbox" checked={formData.quickCheck} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-214" />
                      </div>
                      <div className="ml-3" data-id="element-215">
                        <label htmlFor="quickCheck" className="text-sm text-gray-700" data-id="element-216">
                          Ich möchte den kostenfreien Quick-Check für meine
                          Praxis
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sm:col-span-2 mt-6" data-id="element-217">
                  <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-70" data-id="element-218">
                    {isSubmitting ? 'Wird gesendet...' : 'Anfrage senden'}
                  </button>
                  <p className="mt-3 text-xs text-gray-500 text-center" data-id="element-219">
                    Alle Felder sind Pflichtfelder. Es gelten unsere{' '}
                    <a href="https://neocube.pro/datenschutz/index.html" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-500" data-id="element-220">
                      Datenschutzbestimmungen
                    </a>
                    .
                  </p>
                </div>
              </form>}
          </div>
          <div className="mt-10 lg:mt-0" data-id="element-221">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-222">
              <div className="px-6 py-8" data-id="element-223">
                <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-224">
                  Kontaktieren Sie uns
                </h3>
                <div className="space-y-6" data-id="element-225">
                  <div className="flex" data-id="element-226">
                    <div className="flex-shrink-0" data-id="element-227">
                      <PhoneIcon className="h-6 w-6 text-blue-600" data-id="element-228" />
                    </div>
                    <div className="ml-3 text-gray-700" data-id="element-229">
                      <p className="text-lg font-medium" data-id="element-230">Telefon</p>
                      <p data-id="element-231">040 - 60 77 68555</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-232">
                    <div className="flex-shrink-0" data-id="element-233">
                      <MailIcon className="h-6 w-6 text-blue-600" data-id="element-234" />
                    </div>
                    <div className="ml-3 text-gray-700" data-id="element-235">
                      <p className="text-lg font-medium" data-id="element-236">E-Mail</p>
                      <p data-id="element-237">info@neocube.pro</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-238">
                    <div className="flex-shrink-0" data-id="element-239">
                      <MapPinIcon className="h-6 w-6 text-blue-600" data-id="element-240" />
                    </div>
                    <div className="ml-3 text-gray-700" data-id="element-241">
                      <p className="text-lg font-medium" data-id="element-242">Adresse</p>
                      <p data-id="element-243">
                        PEZULA Projects & Experts GmbH
                        <br data-id="element-244" />
                        Innungsstr. 5
                        <br data-id="element-245" />
                        21244 Buchholz b. Hamburg
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-6 py-8 bg-blue-50 h-full flex flex-col" data-id="element-246">
                <h4 className="text-lg font-medium text-gray-900 mb-4" data-id="element-247">
                  Unsere Servicezeiten
                </h4>
                <div className="space-y-2" data-id="element-248">
                  <div className="flex justify-between" data-id="element-249">
                    <span className="text-gray-600" data-id="element-250">Mo.-Fr.:</span>
                    <span className="font-medium" data-id="element-251">8:00 - 19:00 Uhr</span>
                  </div>
                </div>
                <div className="mt-auto pt-6" data-id="element-252">
                  <a href="https://www.neocube.pro" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-500 font-medium flex items-center" data-id="element-253">
                    <span data-id="element-254">Mehr über neocube erfahren</span>
                    <svg className="ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-255">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-256" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}